<template>
  <div class="header">
    <div class="title">
      {{ title }}
    </div>
    <div class="exit" @click="setExit({status: true})">
      Выход
    </div>
    <div class="add" v-if="getRoute === 'Guides'" @click="setNewGuide">
      Добавить
    </div>
    <div class="filter" v-if="getRoute === 'Guides' && false" @click="setFilterView" :class="{active: filterView}">
      <FilterIcon class="icon" />
    </div>
    <div class="add" v-if="getRoute === 'Promos'" @click="setNewPromo">
      Добавить
    </div>
    <div class="add" v-if="getRoute === 'Home'" @click="saveBanner">
      Сохранить
    </div>
  </div>
</template>

<script>
import FilterIcon from '@/assets/svg/filter-icon.svg?inline'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    FilterIcon
  },
  computed: {
    ...mapState([
      'title'
    ]),
    ...mapState('guides', [
      'filterView'
    ]),
    getRoute () {
      return this.$route.name
    }
  },
  methods: {
    ...mapActions([
      'logOut',
      'setExit'
    ]),
    ...mapActions('guides', [
      'saveBanner',
      'setNewGuide',
      'setFilterView'
    ]),
    ...mapActions('promos', [
      'setNewPromo'
    ]),
    newGuide () {
      this.$router.push({ name: 'Guide' })
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
  @include box(100%, 3vw, relative, 0, 0, null, null, 0, $header);
  box-shadow: $headerShadow;
  z-index: 10;
  .title{
    @include box(15%, 3vw, relative, 0, 0, null, null, 0, null);
    @include flex(center, center, row);
    @include text(0.9vw, 500, 0.07vw, null, center, $headerTitle);
    @include border(null, solid, $headerBorder, null, null, 0.04vw, null);
    text-transform: uppercase;
  }
  .exit, .add, .filter{
    @include box(10vw, 3vw, absolute, null, 0, 0, null, null, null);
    @include flex(center, center, row);
    @include border(null, solid, $headerBorder, 0.04vw, null, null, null);
    @include text(0.8vw, 500, null, null, center, $headerTitle);
    cursor: pointer;
    text-transform: uppercase;
    &:hover{
      @include box(12vw, null, null, null, null, null, null, null, $headerHover);
    }
    &.add{
      @include box(null, null, absolute, 15%, 0, auto, null, null, null);
      @include border(null, solid, $headerBorder, null, null, 0.04vw, null);
    }
    &.filter{
      @include box(6vw, 3vw, absolute, null, 0, 10vw, null, null, null);
      .icon{
        @include size(0.8vw, 0.8vw);
        fill: $headerIcon;
      }
      &.active{
        @include size(8vw, null);
        .icon{
          fill: $headerIconActive;
        }
      }
      &:hover{
        @include size(8vw, null);
      }
    }
    &.exit:hover ~ .filter{
      right: 12vw;
    }
  }
}
</style>
